
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.345 10.715c.652 1.167 1.403 2.288 2.38 3.31.98 1.03 2.196 1.965 3.774 2.763a.396.396 0 00.327.018c.15-.057.302-.18.453-.33.117-.115.261-.3.414-.502.606-.792 1.357-1.774 2.417-1.283.023.01.04.023.064.034l3.536 2.017c.01.005.023.018.034.023.466.318.658.81.663 1.364 0 .567-.21 1.202-.518 1.74-.407.71-1.008 1.179-1.7 1.49-.658.302-1.39.463-2.095.566-1.107.162-2.143.059-3.202-.265-1.037-.319-2.08-.843-3.22-1.542l-.085-.054c-.523-.323-1.088-.67-1.642-1.08-2.03-1.52-4.098-3.715-5.444-6.13C.37 10.825-.245 8.636.092 6.548c.186-1.144.68-2.184 1.543-2.87.751-.601 1.764-.93 3.075-.815.15.01.285.097.354.225L7.33 6.891c.333.427.373.849.193 1.271-.151.348-.454.666-.868.965-.122.103-.268.208-.42.318-.507.365-1.082.786-.885 1.283l-.005-.013zM9.567 8.9a.65.65 0 11.328-1.258c1.062.274 2.06.845 2.867 1.593.813.752 1.443 1.693 1.76 2.701a.65.65 0 01-.43.815.657.657 0 01-.822-.427c-.249-.79-.75-1.534-1.401-2.137-.656-.608-1.458-1.069-2.302-1.287zm.087-3.985a.652.652 0 01-.537-.751c.06-.354.4-.592.757-.532 2.001.343 3.901 1.351 5.424 2.766 1.524 1.414 2.677 3.24 3.184 5.218a.657.657 0 01-1.273.32c-.447-1.738-1.462-3.345-2.804-4.591-1.34-1.244-3.005-2.13-4.751-2.43zm.422-3.617a.652.652 0 01-.577-.72.655.655 0 01.726-.574c2.8.325 5.43 1.6 7.512 3.472 2.088 1.877 3.63 4.361 4.245 7.099a.655.655 0 01-1.278.28c-.555-2.469-1.951-4.715-3.845-6.416-1.885-1.695-4.26-2.848-6.783-3.14z","fill":"var(--theme-color-white-text)"}})])
          )
        }
      }
    